import styles from 'styled-components';

const StyledHeading = styles.h4``;

const Heading4 = ({ children, ...rest }) => (
  <StyledHeading {...rest}>{children}</StyledHeading>
);

export default Heading4;
